/**
 * Process post data and output as media object.
 * @param  {Object} data The post data from the event api.
 * @return {string}      the html markup.
 */
export const filterableEventsTemplate = (data) => {
	// Get Conditional elements.
	let {
		image,
		label,
		meta,
	} = data;

	// Static Elements.
	const {
		url,
		title,
		datetime,
		speakers,
		country,
	} = data;

	// If Image then display image markup.
	if (image) {
		image = `
			<div class="media-object__media">
				<img class="object-fit--cover" alt="${image.alt}" src="${image.src}" />
			</div>`;
	}

	// If label then display label markup.
	if (label) {
		label = `<div class="media-object__label">${label}</div>`;
	}

	// If meta data (time and region) then display meta markup.
	if (datetime) {
		meta = `
			<ul class="media-object__meta meta">
				<li>${datetime}</li>
				<li>${speakers}</li>
				<li classs="event-region">${country}</li>
			</ul>`;
	}

	// The media object.
	const html = `
		<div class="em-col">
			<a class="event-result media-object" href="${url}">
				${image}

				<div class="media-object__body">
					${label}

					<h3 class="media-object__headline h4" itemprop="headline">
						${title}
					</h3>

					${meta}

				</div>

			</a>
		</div>
	`;

	return html;
};

export const noResultsTemplate = (data) => `<div class="em-col"><p class="no-results">${data}</p></div>`;
